import { render, staticRenderFns } from "./DatasheetManagement.vue?vue&type=template&id=985155a8"
import script from "./DatasheetManagement.vue?vue&type=script&lang=js"
export * from "./DatasheetManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports